
(function(){
  function init(root){
    if (root.dataset.ready) return;
    root.dataset.ready = "1";
    var track = root.querySelector(".tramore-caro__track");
    var slides = Array.prototype.slice.call(root.querySelectorAll(".tramore-caro__slide"));
    var dotsWrap = root.querySelector(".tramore-caro__dots");
    var i = 0, startX = 0, dx = 0, dragging = false;
    slides.forEach(function(_, n){
      var b = document.createElement("button");
      b.type = "button";
      b.className = "tramore-caro__dot" + (n===0 ? " is-active" : "");
      b.setAttribute("aria-label", "Slide " + (n+1));
      b.addEventListener("click", function(){ go(n); });
      dotsWrap.appendChild(b);
    });
    function go(n){
      i = (n + slides.length) % slides.length;
      track.style.transform = "translateX(" + (-i*100) + "%)";
      Array.prototype.forEach.call(dotsWrap.children, function(d, k){
        d.classList.toggle("is-active", k===i);
      });
    }
    var prev = root.querySelector(".tramore-caro__btn--prev");
    var next = root.querySelector(".tramore-caro__btn--next");
    if (prev) prev.addEventListener("click", function(){ go(i-1); });
    if (next) next.addEventListener("click", function(){ go(i+1); });
    var vp = root.querySelector(".tramore-caro__viewport");
    vp.addEventListener("pointerdown", function(e){ dragging=true; startX=e.clientX; dx=0; try{vp.setPointerCapture(e.pointerId)}catch(err){}; track.style.transition="none"; });
    vp.addEventListener("pointermove", function(e){ if(!dragging) return; dx=e.clientX-startX; track.style.transform="translateX(calc(" + (-i*100) + "% + " + dx + "px))"; });
    function endDrag(){ if(!dragging) return; dragging=false; track.style.transition=""; if (dx < -40) go(i+1); else if (dx > 40) go(i-1); else go(i); }
    vp.addEventListener("pointerup", endDrag);
    vp.addEventListener("pointercancel", function(){ if(!dragging) return; dragging=false; track.style.transition=""; go(i); });
  }
  function boot(){ document.querySelectorAll("[data-tramore-caro]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();

(function(){
  function initFlip(root){
    if (root.dataset.ready) return;
    root.dataset.ready = "1";
    var items = root.querySelectorAll(".tramore-flip__item");
    if (!items.length) return;
    var i = 0;
    items[0].classList.add("is-on");
    setInterval(function(){
      items[i].classList.remove("is-on");
      i = (i + 1) % items.length;
      items[i].classList.add("is-on");
    }, 2800);
  }
  function bootFlip(){ document.querySelectorAll("[data-tramore-flip]").forEach(initFlip); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bootFlip);
  else bootFlip();
  document.addEventListener("shopify:section:load", bootFlip);
})();

(function(){
  function initChips(root){
    if (root.dataset.ready) return;
    root.dataset.ready = "1";
    var items = root.querySelectorAll(".tramore-chips__item");
    if (!items.length) return;
    var i = 0;
    items[0].classList.add("is-on");
    setInterval(function(){
      items[i].classList.remove("is-on");
      i = (i + 1) % items.length;
      items[i].classList.add("is-on");
    }, 2200);
  }
  function bootChips(){ document.querySelectorAll("[data-tramore-chips]").forEach(initChips); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bootChips);
  else bootChips();
  document.addEventListener("shopify:section:load", bootChips);
})();
